// ============================================================================
// SN-Link Constants — VID/PID Candidates, Command Opcodes
// ============================================================================
//
// Note: Exact VID/PID must be confirmed by connecting SN-Link V3 hardware
// and checking USB descriptors. The values below are candidates.

/** Candidate Sonix/SN-Link Vendor IDs */
export const SNLINK_CANDIDATE_VIDS = [
  0x0C45,  // Sonix / Microdia (shared with webcam products)
  0x320F,  // Alternate Sonix programmer VID
] as const;

/** HID device filters for navigator.hid.requestDevice() */
export const SNLINK_HID_FILTERS: HIDDeviceFilter[] = [
  { vendorId: 0x0C45 },
  { vendorId: 0x320F },
];

/** SN-Link ISP command opcodes */
export enum SnLinkCmd {
  CONNECT      = 0x30,
  DISCONNECT   = 0x31,
  READ_ID      = 0x32,
  ERASE        = 0x33,
  PROGRAM      = 0x34,
  VERIFY       = 0x35,
  READ         = 0x36,
  GET_INFO     = 0x37,
  SET_OPTION   = 0x38,
  RUN          = 0x39,
  GET_FW_VER   = 0x3A,
  BLANK_CHECK  = 0x3B,
}

/** HID report size for SN-Link communications */
export const SNLINK_REPORT_SIZE = 64;

/** Max data payload per write command */
export const SNLINK_MAX_WRITE_PAYLOAD = 56;
